const $translate = (key) => {
  let translation = window.i18nKeys[key];
  return translation;
}

export default {
  install: (app) => {
    app.config.globalProperties.$translate = $translate
    app.provide('i18n', { $translate })
  }
}